<ng-container *ngIf="validJobTitles">
  <div class="badges-count" *ngFor="let item of validJobTitles" >
    <i class="app-ico app-ico__job-title-valid tooltip" (click)="openReport(item.reportUrl)"></i>
    <div class="tooltiptext" *ngIf="item.reportUrl">
      <!-- The users job title {{ item }} is validated by Atalef. -->
       Click here to see Report.
    </div>
  </div>
</ng-container>

<ng-container *ngIf="validSkills && validSkills.length <= 4">
  <div class="badges-count" *ngFor="let item of validSkills">
    <i class="app-ico app-ico__skill-valid tooltip" (click)="openReport(item.reportUrl)"></i>
    <div class="tooltiptext" *ngIf="item.reportUrl">
      <!-- The users skills {{ item }} is validated by Atalef. -->
       Click here to see Report.
    </div>
  </div>
</ng-container>

<ng-container *ngIf="validSkills && validSkills.length > 4">
  <div class="badges-count-bulk">
    <i class="app-ico app-ico__skill-valid tooltip"></i>
    <div class="tooltiptext">
      This user has {{ validSkills.length }} skills validated by Atalef.
    </div>
    <span>x{{ validSkills.length }}</span>
  </div>
</ng-container>